import { useContext, useState, useCallback } from "react";
import CheatsContext from "../context/CheatsContext";
import { db } from "../firebase";
import useUser from "hooks/useUser";
import createSlug from "global/function";

export function useCheats(refresh) {
  const { cheats, setCheats } = useContext(CheatsContext);
  const { currentgame, setCurrentgame } = useContext(CheatsContext);
  const { loadingCheats, setLoadingCheats } = useContext(CheatsContext);
  const { editingCheat, setEditingCheat } = useContext(CheatsContext);
  const { currentCheat, setCurrentCheat } = useContext(CheatsContext);
  const { questions, setQuestions } = useContext(CheatsContext);
  const { categories, setCategories } = useContext(CheatsContext);
  const [errorCheats, setErrorCheats] = useState({ status: false, msg: "" });
  const [ok, setOk] = useState({ status: false, msg: "" });
  const [deletedCheat, setDeletedCheat] = useState({ status: false, msg: "" });
  const { error, success, profile, loadingUser, refreshUserProfile } =
    useUser();

  const getCheats = useCallback(() => {
    var getCheats = [];
    setLoadingCheats(true);
    db.collection("cheats")
      .orderBy("updateDate", "desc")
      .get()
      .then((querySnapshot) => {
        setLoadingCheats(true);
        querySnapshot.forEach((doc) => {
          getCheats.push({ ...doc.data(), id: doc.id });
        });
      })
      .then((e) => {
        setCheats(getCheats);
        setLoadingCheats(false);
      });
  });

  const createCheat = useCallback((cheat) => {
    refreshUserProfile();
    //controlamos que sea administrador el usuaio
    if (!loadingUser && profile && profile.admin) {
      setLoadingCheats(true);
      db.collection("cheats")
        .add(cheat)
        .then(() => {
          setErrorCheats({ status: false, msg: "" });
          setOk({ status: true, msg: "Cheat added successfully" });
          setTimeout(() => {
            setOk({ status: false, msg: "" });
            getCheats();
            setLoadingCheats(false);
          }, 1000);
        })
        .catch((error) => {
          console.error("Error create document: ", error);
        });
    } else {
      setErrorCheats({ status: true, msg: "Error." });
    }
  });

  const deleteCheat = useCallback(async (idcheat) => {
    refreshUserProfile();
    if (!loadingUser && profile && profile.admin) {
      setLoadingCheats(true);
      db.collection("cheats")
        .doc(idcheat)
        .delete()
        .then(() => {
          setErrorCheats({ status: false, msg: "" });
          setDeletedCheat({ status: true, msg: "Cheat removed successfully" });
          setTimeout(() => {
            setDeletedCheat({ status: false, msg: "" });
            getCheats();
            setLoadingCheats(false);
          }, 2000);
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    }
  });

  const updateCheat = useCallback(async (cheat) => {
    refreshUserProfile();
    if (!loadingUser && profile && profile.admin) {
      db.collection("cheats")
        .doc(cheat.id)
        .update(cheat)
        .then((data) => {
          setErrorCheats({ status: false, msg: "" });
          setOk({ status: true, msg: "Cheat updated successfully" });
          setTimeout(() => {
            setOk({ status: false, msg: "" });
            getCheats();
            setLoadingCheats(false);
          }, 1000);
        })
        .catch((error) => {
          console.error("Error update document: ", error);
        });
    }
  });

  const getCurrentCheat = useCallback(async (slug) => {
    setLoadingCheats(true);
    db.collection("cheats")
      .where("slug", "==", slug)
      .get()
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          querySnapshot.forEach((doc) => {
            setCurrentCheat({ ...doc.data(), id: doc.id });
          });
          setLoadingCheats(false);
        } else {
          window.location.href = "/";
        }
      })
      .catch((error) => {
        setLoadingCheats(false);
        console.error("Error get document: ", error);
      });
  });

  const getQuestions = useCallback(() => {
    var getQuestions = [];
    db.collection("questions")
      .orderBy("number", "asc")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          getQuestions.push({ ...doc.data(), id: doc.id });
        });
      })
      .then((e) => {
        setQuestions(getQuestions);
      });
  });

  const getCategories = useCallback(() => {
    var getCategories = [];
    db.collection("categories")
      .orderBy("position", "asc")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          getCategories.push({ ...doc.data(), id: doc.id });
        });
      })
      .then((e) => {
        setCategories(getCategories);
      });
  });

  const likeCheat = useCallback(async (cheat) => {
    const updatedCheat = { ...cheat, likes: cheat.likes + 1 };
    db.collection("cheats")
      .doc(cheat.id)
      .update(updatedCheat)
      .then((data) => {})
      .catch((error) => {
        console.error("Error update document: ", error);
      });
  });

  return {
    loadingCheats,
    setLoadingCheats,
    cheats,
    setCheats,
    ok,
    error,
    setErrorCheats,
    setOk,
    createCheat,
    getCheats,
    deleteCheat,
    updateCheat,
    currentgame,
    setCurrentgame,
    editingCheat,
    setEditingCheat,
    currentCheat,
    setCurrentCheat,
    getCurrentCheat,
    questions,
    getQuestions,
    categories,
    getCategories,
  };
}
